import { EAccountStatus, ISession } from '../../types';
export default function hasAccount(session: ISession): boolean {
  if (!session.accounts || !session.accounts.length) {
    return false;
  }
  return (
    session.accounts.filter(
      (a) => a.status === EAccountStatus.active && !a.deletionDate
    ).length > 0
  );
}
